<template>
  <div class="container">
    <p class="text-h4 my-4">Notifications</p>

    <v-progress-linear v-if="loading" indeterminate />

    <template v-else-if="notifications.length > 0">
      <div class="list">
        <div
          v-for="(notification, index) in notifications"
          :key="index"
          class="notifications pa-4"
        >
          <p v-if="notification.title" class="text-body-1 font-weight-bold">
            {{ notification.title }}
          </p>
          <p v-if="notification.text" class="text-body-1">
            {{ notification.text }}
          </p>
        </div>
      </div>
      <base-paginator
        v-if="notifications.length > 0"
        :items-per-page="params.itemsPerPage"
        :page="params.page"
        :total="total"
        @change="params.page = $event"
      />
    </template>

    <p v-else class="text-body-1 ">You don't have any notifications.</p>
  </div>
</template>

<script>
import api from '@/api'

export default {
  name: 'NotificationsPage',

  data: () => ({
    loading: true,
    notifications: [],
    params: {
      itemsPerPage: 10,
      page: 1,
    },
    total: 0,
  }),

  watch: {
    'params.page'() {
      this.getList()
    },
  },

  mounted() {
    this.getList()
  },

  methods: {
    async getList() {
      this.loading = true

      try {
        const res = await api.notifications.list({
          params: {
            page: this.params.page,
            size: this.params.itemsPerPage,
          },
        })

        this.total = res.data.total
        this.notifications = res.data.data.notifications
        this.loading = false

        console.log(res.data.data)
      } catch (error) {
        console.error(error)
      }
    },
  },
}
</script>

<style scoped>
.container {
  margin: 0 auto;
  max-width: 1920px;
  width: 90%;
}

.list {
  background: white;
  border-radius: 5px;
  box-shadow: 0px 4px 4px 4px #00000005;
}

.list > div {
  border-bottom: 1px solid #e0e0e0;
}

.list > div:last-of-type {
  border-bottom: none !important;
}
</style>
